<template>
  <summary-table
    data-field="poy"
    format-type="poy"
  />
</template>

<script>
import SummaryTable from '@core/components/summary/SummaryTable.vue'

export default {
  name: 'TotalPoy',
  components: {
    SummaryTable,
  },
}
</script>
